export class UnauthorisedError extends Error {
  constructor(message = '401', redirectURL) {
    super(message)
    this.name = 'UnauthorizedError'
    this.status = 401
    this.redirectURL = redirectURL
    this.report = false
  }
}
